import React from 'react'
import { CSpinner } from '@coreui/react'
import './index.css'

const Loader = () => {
  return (
    <div className="loader">
      <CSpinner />
    </div>
  )
}
export default Loader
